export default __webpack_public_path__ + "static/team-peter@2x-bfdc267fd9d1fc4ddd76cdf2deba659a.png";